import { SidePanelSubmittalsEndPoints } from "apis/EndPoints/SidePanelSubmittalsEndPoints";
import { Network } from "../Network";

export class SidePanelSubmittalsService {
  static procurementLogReadSpecificSubmittalSidePanel(data = {}) {
    return Network.fetch(
      SidePanelSubmittalsEndPoints.procurementLogReadSpecificSubmittalSidePanel.url(
        data.company_id,
        data.id,
        data.entryID
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data.email,
        },
        method:
          SidePanelSubmittalsEndPoints
            .procurementLogReadSpecificSubmittalSidePanel.method,
      }
    );
  }
  static retrieveUserTokens(data = {}) {
    return Network.fetch(
      SidePanelSubmittalsEndPoints.retrieveUserTokens.url(),
      {
        headers: {
          // "Content-type": "application/json",
          // Authorization: data?.code,
          From: data.email,
        },
        method: SidePanelSubmittalsEndPoints.retrieveUserTokens.method,
      }
    );
  }
  static procurementLogContractorEditEntry(data = {}) {
    return Network.fetch(
      SidePanelSubmittalsEndPoints.procurementLogContractorEditEntry.url(
        data.company_id,
        data.id
      ),
      {
        headers: {
          "Content-type": "application/json",
          // Authorization: data?.code,
          From: data.email,
        },
        method:
          SidePanelSubmittalsEndPoints.procurementLogContractorEditEntry.method,
        body: JSON.stringify(data.entries),
      }
    );
  }
}
